import { PART_PRICE } from '../../constants';
import { formatCurrency } from '../../helpers/formatCurrency';
import { getProductLabels } from '../../helpers/getProductLabels';

import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import StatusPill from 'components/StatusPill';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const RecommendationRow: FunctionComponent<Props> = ({
    canAddToCart,
    className = '',
    droneNames,
    onAdd,
    recommendation,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const price = PART_PRICE[recommendation.partId];
    const lineTotal = price * recommendation.qty;
    const droneLabel = recommendation.droneIds.map(id => droneNames[id] ?? id).join(', ');
    const isUrgent = recommendation.urgency === 'urgent';
    const meta = `${formatCurrency(price)} × ${recommendation.qty} = ${formatCurrency(lineTotal)} · Drones: ${droneLabel}`;

    return (
        <HorizontalContainer className={`${styles.partRow} ${className}`} testId={testId}>
            <StatusPill
                text={isUrgent ? t.URGENCY_URGENT : t.URGENCY_DUE_SOON}
                variant={isUrgent ? 'error' : 'warn'}
            />

            <VerticalContainer className={styles.partRowMain}>
                <Wrapper className={styles.partName}>
                    {getProductLabels(t)[recommendation.partId]}
                </Wrapper>

                <Wrapper className={styles.partMeta}>{meta}</Wrapper>
            </VerticalContainer>

            {canAddToCart && (
                <Wrapper className={styles.addToCartBtn} onClick={() => onAdd(recommendation)}>
                    {t.ADD_TO_CART}
                </Wrapper>
            )}
        </HorizontalContainer>
    );
};

export default RecommendationRow;
